import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ConfirmWithTextInputDialogData {
  title: string;
  message: string;
  expectedText: string;
  inputLabel: string;
  confirmText?: string;
  cancelText?: string;
}

@Component({
  selector: 'confirm-with-text-input-dialog',
  templateUrl: 'confirm-with-text-input-dialog.component.html',
  styleUrls: ['confirm-with-text-input-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmWithTextInputDialogComponent {
  textInputControl = new FormControl('', [
    Validators.required,
    Validators.pattern(`^${this.data.expectedText}$`),
  ]);

  constructor(
    public dialogRef: MatDialogRef<ConfirmWithTextInputDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmWithTextInputDialogData,
  ) {}

  cancel(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    if (this.textInputControl.valid) {
      this.dialogRef.close(true);
    }
  }
}
